import React from "react";

const Button = ({
  backgroundColor,
  textColor,
  width,
  fontSize,
  fontFamily,
  borderRadius,
  fontWeight,
  padding,
  border,
  margin,
  children,
  onClick,
  isLoading,
  display,
  lockicondisplay,
  type = "button",
    disabled = false
}) => {
  const buttonStyle = {
    backgroundColor,
    color: textColor,
    width,
    fontSize,
    fontFamily,
    padding,
    margin,
    borderRadius,
    border,
    fontWeight,
    onClick,
  };

  return (
      <button
          disabled={disabled}
        type={type}
        onClick={onClick}
        className="flex  items-center gap-2 justify-center hover:shadow-lg rounded-md w-full  font-poppins"
        style={buttonStyle}
      >
        {children}
      </button>
  );
};

export default Button;
